import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './services';
import { Constants } from './common';

export const routes: Routes = [
    { path: Constants.APP_ROUTES.home, redirectTo: Constants.APP_ROUTES.dashboard, pathMatch: 'full' },
    {
        path: Constants.APP_ROUTES.login,
        loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
        canActivate: [guestGuard],
    },
    {
        path: Constants.APP_ROUTES.dashboard,
        loadComponent: () =>
            import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [authGuard],
    },
    {
        path: Constants.APP_ROUTES.businessList,
        loadComponent: () =>
            import('./pages/business/business.component').then((m) => m.BusinessComponent),
        canActivate: [authGuard],
    },
    {
        path: Constants.APP_ROUTES.businessDetail(':id'),
        loadComponent: () =>
            import('./pages/business/business-detail/business-detail.component').then(
                (m) => m.BusinessDetailComponent,
            ),
        canActivate: [authGuard],
    },
    {
        path: Constants.APP_ROUTES.adManager,
        loadComponent: () =>
            import('./pages/ad-manager/ad-manager.component').then((m) => m.AdManagerComponent),
        canActivate: [authGuard],
    },
    {
        path: Constants.APP_ROUTES.screensList,
        loadComponent: () =>
            import('./pages/screens/screens.component').then((m) => m.ScreensComponent),
        canActivate: [authGuard],
    },
    {
        path: Constants.APP_ROUTES.screenDetail(':id'),
        loadComponent: () =>
            import('./pages/screen-detail/screen-detail.component').then(
                (m) => m.ScreenDetailComponent,
            ),
        canActivate: [authGuard],
    },
    { path: '**', redirectTo: Constants.APP_ROUTES.dashboard },
];
